/**
 * Pantalla de error genérica para errores de backend (404, 500)
 * Rutas: /404 y /500
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ButtonComponent from '../components/ButtonMC';
import errorPageImage from 'images/error-page.png';

const ErrorPageScreenMC = ({ errorType = 'internal_error' }) => {
  const { t } = useTranslation('ErrorScreensMC');
  const navigate = useNavigate();
  const { retailer_info } = useSelector((state) => state.retailerUsersReducer);

  const isNotFound = errorType === 'not_found';

  const handleBackToDashboard = () => {
    if (retailer_info?.slug) {
      navigate(`/retailers/${retailer_info.slug}/dashboard`);
    } else {
      navigate('/');
    }
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      handleBackToDashboard();
    }
  };

  return (
    <div className="tw-wrapper">
      <div
        className="md:tw-ml-[60px] tw-min-h-[calc(100vh-60px)] tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4"
        style={{ background: 'linear-gradient(180deg, #FFF 55.1%, #EAFEFF 100%)' }}
      >
        <h1 className="tw-text-3xl tw-font-semibold tw-text-blue-500 tw-mb-4 tw-text-center">
          {isNotFound ? t('error_page.not_found_title') : t('error_screen.title')}
        </h1>

        <p className="tw-text-gray-700 tw-mb-6 tw-text-base tw-text-center tw-max-w-lg">
          {isNotFound ? t('error_page.not_found_description') : t('error_screen.description')}
        </p>

        <div className="tw-flex tw-justify-center tw-mb-8">
          <img
            src={errorPageImage}
            alt="Error"
            className="tw-w-44 tw-h-auto"
          />
        </div>

        <div className="tw-flex tw-flex-row tw-gap-4 tw-items-center">
          <ButtonComponent
            text={t('error_screen.back_to_dashboard')}
            variant="SECONDARY"
            onClick={handleBackToDashboard}
            size="medium"
            outlined
          />

          {!isNotFound && (
            <ButtonComponent
              text={t('error_page.try_again')}
              variant="PRIMARY"
              onClick={handleGoBack}
              size="medium"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorPageScreenMC;
